import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Urbaniaonrentinwakad() {



    const cardData =
    {
        keyword: 'Urbania On Rent in Wakad',
        heading: 'Urbania on rent in pune: Urbania On Rent in Wakad',
        headingDescription: 'Urbania On Rent in Pune offers reliable and comfortable Urbania on Rent in Wakad for corporate groups, families, tourists, and event travelers across the area. Our well-maintained Force Urbania fleet provides spacious seating, air-conditioned comfort, and smooth performance, making it ideal for corporate travel, airport transfers, weddings, sightseeing, and outstation journeys from Wakad. With professional chauffeurs, flexible one-way and round-trip rental options, and convenient doorstep pickup from Wakad, Hinjewadi, Balewadi, Baner, Pashan, Aundh, and Pune Airport, we ensure a safe and stress-free travel experience. Backed by 24/7 booking support, punctual service, and transparent pricing, Urbania On Rent in Pune stands out as the trusted choice for premium Urbania hire in Wakad.',

        top: 'Top Places to Visit in Pune with Urbania on rent in pune',


"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732 by the Peshwas, is Pune’s most iconic historical fort and a powerful symbol of Maratha pride. Once the administrative center of Bajirao I, it features massive stone walls, majestic gates like the Delhi Darwaza, and spacious courtyards. Although a major fire destroyed much of the structure, the remaining fort reflects royal grandeur. The evening light-and-sound show narrates Maratha history, making it a must-visit heritage landmark."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace is one of Pune’s most important landmarks connected to India’s freedom struggle. Built in 1892, it served as a prison for Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai during the Quit India Movement. The palace now houses a museum displaying Gandhi’s personal belongings, photographs, and letters. Its Italian-style arches, lush lawns, and peaceful environment make it both historically significant and visually stunning."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most famous and revered Ganesh temple. The idol is richly adorned with gold ornaments and attracts thousands of devotees daily. During Ganesh Chaturthi, the temple becomes the heart of Pune’s grand celebrations with processions and cultural programs. The temple trust is also well known for its social and charitable initiatives, making it spiritually and socially significant."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort is a historic hill fortress located amidst the Sahyadri ranges and is famous for the legendary battle fought by Tanaji Malusare. The fort offers panoramic views of Pune city, ancient bastions, memorials, and scenic trekking routes. Visitors enjoy traditional Maharashtrian food like pithla-bhakri at the top. It is a perfect destination combining history, adventure, and natural beauty."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an 8th-century rock-cut temple dedicated to Lord Shiva, carved from a single basalt rock. It features monolithic pillars, a circular Nandi mandap, and ancient carvings reflecting early Indian craftsmanship. Despite being located in a busy area, the temple maintains a calm and spiritual ambiance, offering a peaceful retreat within the city."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "The Raja Dinkar Kelkar Museum houses over 20,000 artifacts collected from across India, showcasing traditional art, musical instruments, sculptures, and household items. One of its highlights is the recreated Mastani Mahal. The museum offers deep insight into India’s cultural heritage and is a treasure trove for history lovers, students, and art enthusiasts."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill is one of Pune’s oldest landmarks and offers breathtaking panoramic views after climbing 103 stone steps. The hilltop Parvati Temple, built during the Peshwa era, is dedicated to Lord Shiva and Goddess Parvati. The complex also includes smaller shrines and a museum. Sunrise and sunset views from the hill are especially captivating."
  },
  {
    "title": "Osho International Meditation Resort",
    "description": "Located in Koregaon Park, the Osho International Meditation Resort is a globally renowned center for meditation, mindfulness, and wellness. Surrounded by lush gardens, it attracts visitors from around the world seeking peace, relaxation, and self-discovery. The serene atmosphere and unique meditation techniques make it a distinctive spiritual destination in Pune."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped garden. It features flowing water streams, stone bridges, manicured lawns, and seasonal flowers. The garden offers a peaceful environment for walks, photography, and family outings, beautifully blending Japanese aesthetics with Indian natural beauty."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular picnic and leisure spot near Pune. The expansive water body, surrounding hills, and cool breezes create a scenic setting, especially during monsoon and evenings. Local vendors selling corn and tea add to its charm. It also serves as the gateway to Sinhagad Fort, making it a favorite weekend getaway."
  }
],



"services": [
    {
      "name": "Urbania on Rent in Wakad",
      "description": "Urbania on Rent in Wakad offers comfortable and reliable Urbania vehicles for local travel, corporate requirements, and group transportation. With spacious seating, clean interiors, and professional chauffeurs, this service ensures a smooth, safe, and convenient travel experience across Wakad and Pune."
    },
    {
      "name": "Wakad Urbania Bus Hire",
      "description": "Wakad Urbania Bus Hire provides spacious buses suitable for group travel, corporate outings, and family events. Vehicles are well-maintained and driven by experienced chauffeurs, ensuring punctual and comfortable transportation for short city trips and longer journeys."
    },
    {
      "name": "Urbania Rental Service Wakad Pune",
      "description": "Urbania Rental Service Wakad Pune delivers dependable rental solutions for local and outstation travel. With a fleet of well-maintained vehicles and trained drivers, passengers enjoy comfortable, safe, and hassle-free transportation."
    },
    {
      "name": "Urbania AC Bus on Rent Wakad",
      "description": "Urbania AC Bus on Rent Wakad offers fully air-conditioned buses designed for maximum comfort during group travel. Ideal for corporate events, weddings, and tours, this service ensures a pleasant journey with professional chauffeur support."
    },
    {
      "name": "Corporate Urbania Hire Wakad",
      "description": "Corporate Urbania Hire Wakad provides professional transportation solutions for offices, IT companies, and business travel. With punctual service, executive comfort, and trained chauffeurs, it is ideal for meetings, conferences, and employee transportation."
    },
    {
      "name": "Urbania for Outstation Wakad Pune",
      "description": "Urbania for Outstation Wakad Pune ensures safe and comfortable long-distance travel with highway-experienced chauffeurs. Suitable for family tours, pilgrimages, and corporate trips, this service focuses on reliability, comfort, and timely travel."
    },
    {
      "name": "Urbania Airport Transfer Wakad",
      "description": "Urbania Airport Transfer Wakad offers timely and hassle-free pickup and drop services to and from Pune Airport. With spacious vehicles, air-conditioned comfort, and professional drivers, passengers enjoy stress-free airport travel."
    },
    {
      "name": "Luxury Urbania Wakad",
      "description": "Luxury Urbania Wakad provides premium Urbania vehicles with plush interiors and superior ride quality. Ideal for VIP travel, weddings, and executive transportation, this service delivers a stylish and comfortable travel experience."
    },
    {
      "name": "Affordable Urbania Hire Wakad",
      "description": "Affordable Urbania Hire Wakad offers cost-effective rental options without compromising comfort or service quality. Suitable for families, groups, and office travel, it ensures reliable vehicles and transparent pricing."
    },
    {
      "name": "Chauffeur Driven Urbania Wakad",
      "description": "Chauffeur Driven Urbania Wakad ensures stress-free travel with trained and background-verified chauffeurs. Vehicles are clean, spacious, and well-maintained, allowing passengers to relax and enjoy a safe journey."
    },
    {
      "name": "Urbania for Wedding Events Wakad",
      "description": "Urbania for Wedding Events Wakad provides organized and elegant transportation for wedding guests and family members. With comfortable seating, professional chauffeurs, and punctual service, it helps manage wedding travel smoothly."
    },
    {
      "name": "Urbania for Office Trips Wakad",
      "description": "Urbania for Office Trips Wakad delivers dependable transportation for daily office commutes, team outings, and corporate events. With a focus on punctuality and comfort, it ensures professional travel for employees."
    },
    {
      "name": "Best Urbania Rental Wakad Pune",
      "description": "Best Urbania Rental Wakad Pune offers top-rated Urbania rental services known for vehicle quality, reliable operations, and customer satisfaction. Ideal for all travel needs, it guarantees a safe and comfortable experience."
    },
    {
      "name": "Urbania Group Travel Wakad",
      "description": "Urbania Group Travel Wakad specializes in transporting groups comfortably and efficiently. Whether for tours, corporate outings, or social events, this service provides spacious vehicles and professional chauffeurs for seamless group travel."
    },
    {
      "name": "Reliable Urbania Hire Wakad Pune",
      "description": "Reliable Urbania Hire Wakad Pune focuses on safety, punctuality, and customer satisfaction. With experienced drivers and well-maintained vehicles, it offers dependable transportation solutions for local, outstation, and event travel."
    }
  ],
  "tableData": [
    ["Urbania on Rent in Wakad", "Wakad Urbania Bus Hire"],
    ["Urbania Rental Service Wakad Pune", "Urbania AC Bus on Rent Wakad"],
    ["Corporate Urbania Hire Wakad", "Urbania for Outstation Wakad Pune"],
    ["Urbania Airport Transfer Wakad", "Luxury Urbania Wakad"],
    ["Affordable Urbania Hire Wakad", "Chauffeur Driven Urbania Wakad"],
    ["Urbania for Wedding Events Wakad", "Urbania for Office Trips Wakad"],
    ["Best Urbania Rental Wakad Pune", "Urbania Group Travel Wakad"],
    ["Reliable Urbania Hire Wakad Pune", ""]
  ],



"whychoose": [
    {
        "WhyChooseheading": "Reliable Urbania On Rent in Wakad",
        "WhyChoosedescription": "Urbania On Rent in Wakad is a perfect choice for comfortable and spacious group travel, suitable for family outings, corporate trips, weddings, airport transfers, and local travel."
    },
    {
        "WhyChooseheading": "Spacious and Comfortable Force Urbania Vehicles",
        "WhyChoosedescription": "Urbania On Rent in Wakad provides well-maintained Force Urbania vehicles with ample seating and luggage space to ensure a smooth and enjoyable journey."
    },
    {
        "WhyChooseheading": "Professional and Experienced Drivers",
        "WhyChoosedescription": "Urbania On Rent in Wakad comes with experienced drivers who are familiar with Wakad city routes, Pune highways, and outstation roads, ensuring safe and timely travel."
    },
    {
        "WhyChooseheading": "Transparent and Affordable Pricing",
        "WhyChoosedescription": "Choose Urbania On Rent in Wakad for competitive rental rates with no hidden charges, making group travel budget-friendly and reliable."
    },
    {
        "WhyChooseheading": "24/7 Booking and Customer Support",
        "WhyChoosedescription": "Urbania On Rent in Wakad provides round-the-clock booking assistance and customer support to help with reservations, inquiries, and last-minute travel needs."
    },
    {
        "WhyChooseheading": "Flexible Rental Packages",
        "WhyChoosedescription": "Urbania On Rent in Wakad is available for hourly rentals, full-day bookings, local and outstation trips, corporate travel, and event transportation."
    },
    {
        "WhyChooseheading": "Clean, Sanitized, and Well-Maintained Vehicles",
        "WhyChoosedescription": "All Urbania vehicles on rent in Wakad are regularly cleaned, sanitized, and serviced to ensure passenger comfort and safety."
    },
    {
        "WhyChooseheading": "Punctual and Reliable Service",
        "WhyChoosedescription": "Urbania On Rent in Wakad guarantees timely pickups and dependable service for stress-free travel experiences."
    }
]
}

const faqData = [
    {
        question: 'Is Urbania On Rent in Wakad available for both local and outstation travel?',
        answer: 'Yes, Urbania On Rent in Wakad can be booked for local city travel as well as outstation trips and airport transfers.',
    },
    {
        question: 'How can I book Urbania On Rent in Wakad?',
        answer: 'You can book Urbania On Rent in Wakad via phone, WhatsApp, or online booking for quick and hassle-free reservations.',
    },
    {
        question: 'Why should I choose Urbania On Rent in Wakad?',
        answer: 'Urbania On Rent in Wakad offers spacious seating, comfortable interiors, professional drivers, and affordable pricing for all travel needs.',
    },
    {
        question: 'Are drivers experienced with Urbania On Rent in Wakad?',
        answer: 'Yes, all drivers are professionally trained, licensed, and familiar with city routes and highway travel for your safety and comfort.',
    },
    {
        question: 'Can I customize pickup and drop-off locations?',
        answer: 'Absolutely. Urbania On Rent in Wakad allows flexible pickup and drop-off locations across Wakad, Pune, and nearby areas.',
    },
    {
        question: 'Is Urbania On Rent in Wakad available 24x7?',
        answer: 'Yes, Urbania On Rent in Wakad operates 24x7 to meet your travel needs at any time of day or night.',
    },
    {
        question: 'Are hygiene and safety standards maintained?',
        answer: 'Yes, all Urbania vehicles are regularly cleaned, sanitized, and maintained with strict safety protocols.',
    },
    {
        question: 'What payment options are available?',
        answer: 'Urbania On Rent in Wakad accepts UPI, digital wallets, credit/debit cards, bank transfers, and corporate billing options.',
    },
    {
        question: 'Is customer support available during the journey?',
        answer: 'Yes, dedicated customer support is available throughout the journey to ensure smooth and stress-free travel.',
    },
    {
        question: 'Can Urbania On Rent in Wakad be used for events and functions?',
        answer: 'Yes, Urbania On Rent in Wakad is ideal for weddings, events, corporate trips, airport transfers, and local celebrations.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Sachin Patil',
        feedback: 'We booked Urbania On Rent in Wakad for our family trip. The vehicle was spacious, clean, and the driver was professional. Excellent service!',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Anjali Deshmukh',
        feedback: 'Urbania On Rent in Wakad provided smooth and dependable service for our corporate outing. Highly recommended!',
        rating: 5,
    },
];









































































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Urbania On Rent Pune", link: "urbania-on-rent-pune" },
        { place: "/images/keyword/2.jpg", text: "Urbania on Rent in Pimpri Chinchwad", link: "urbania-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/3.jpg", text: "Urbania Hire for Corporate Events in Pune", link: "urbania-hire-for-corporate-events-in-pune" },
        { place: "/images/keyword/4.jpg", text: "17 Seater Urbania on Rent in Pune", link: "17-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/5.jpg", text: "14 Seater Urbania on Rent in Pune", link: "14-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/6.jpg", text: "Urbania on Rent in Kharadi", link: "urbania-on-rent-in-kharadi" },
        { place: "/images/keyword/7.jpg", text: "Urbania on Rent in Hadapsar", link: "urbania-on-rent-in-hadapsar" },
        { place: "/images/keyword/8.jpg", text: "Urbania on Rent in Kothrud", link: "urbania-on-rent-in-kothrud" },
        { place: "/images/keyword/9.jpg", text: "Urbania On Rent in Bibwewadi", link: "urbania-on-rent-in-bibwewadi" },
        { place: "/images/keyword/10.jpg", text: "Urbania on Rent in Koregaon Park", link: "urbania-on-rent-in-koregaon-park" },
        { place: "/images/keyword/11.jpg", text: "Urbania On Rent in Kalyani Nagar", link: "urbania-on-rent-in-kalyani-nagar" },
        { place: "/images/keyword/12.jpg", text: "Urbania On Rent in Mundhwa Pune", link: "urbania-on-rent-in-mundhwa-pune" },
        { place: "/images/keyword/13.jpg", text: "Urbania Bus On Rent in Baner", link: "urbania-bus-on-rent-in-baner" },
        { place: "/images/keyword/14.jpg", text: "Urbania AC Bus On Rent in Aundh", link: "urbania-ac-bus-on-rent-in-aundh" },
        { place: "/images/keyword/15.jpg", text: "Urbania Bus On Rent in Hinjewadi", link: "urbania-bus-on-rent-in-hinjewadi" },
        { place: "/images/keyword/16.jpg", text: "Urbania on Rent in Bhosari", link: "urbania-on-rent-in-bhosari" },
        { place: "/images/keyword/17.jpg", text: "Urbania on Rent in Pune Station", link: "urbania-on-rent-in-pune-station" },
        { place: "/images/keyword/18.jpg", text: "Urbania On Rent in Chakan", link: "urbania-on-rent-in-chakan" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Moshi", link: "urbania-on-rent-in-moshi" },
        { place: "/images/keyword/20.jpg", text: "Urbania On Rent in Charholi Budruk", link: "urbania-on-rent-in-charholi-budruk" },
        { place: "/images/keyword/21.jpg", text: "Urbania On Rent in Nigdi Pradhikaran", link: "urbania-on-rent-in-nigdi-pradhikaran" },
        { place: "/images/keyword/22.jpg", text: "Urbania On Rent in Lohegaon", link: "urbania-on-rent-in-lohegaon" },
        { place: "/images/keyword/23.jpg", text: "Urbania On Rent in Wagholi", link: "urbania-on-rent-in-wagholi" },
        { place: "/images/keyword/24.jpg", text: "Urbania Rental Service in Pune", link: "urbania-rental-service-in-pune" },
        { place: "/images/keyword/25.jpg", text: "Best Urbania on Rent in Pune", link: "best-urbania-on-rent-in-pune" }
    ];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Urbania On Rent in Wakad",
  "image": "https://urbaniaonrentpune.in/assets/images/urbania-wakad-pune.jpg",
  "description": "Urbania On Rent in Wakad offers AC and non-AC Urbania buses for corporate trips, outstation travel, airport transfers, weddings, office trips, and group travel. Chauffeur-driven buses provide safe, comfortable, and convenient transportation in Wakad and surrounding areas.",
  "brand": {
    "@type": "Brand",
    "name": "Urbania on Rent in Pune"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "950",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1500",
    "availability": "https://schema.org/InStock",
    "url": "https://urbaniaonrentpune.in/urbania-on-rent-wakad"
  }
};





    return (
        <div>

<Helmet>
  <title>
    Call:+91 9209423113 | Urbania On Rent in Wakad | AC & Luxury Urbania Bus Hire 
  </title>

  <meta
    name="description"
    content="Book Urbania On Rent in Wakad for corporate trips, outstation travel, airport transfers, weddings, office trips, and group travel. AC and non-AC Urbania buses with chauffeur-driven service ensure safe, comfortable, and convenient transportation in Wakad Pune."
  />

  <meta
    name="keywords"
    content="Urbania on Rent in Wakad, Wakad Urbania Bus Hire, Urbania Rental Service Wakad Pune, Urbania AC Bus on Rent Wakad, Corporate Urbania Hire Wakad, Urbania for Outstation Wakad Pune, Urbania Airport Transfer Wakad, Luxury Urbania Wakad, Affordable Urbania Hire Wakad, Chauffeur Driven Urbania Wakad, Urbania for Wedding Events Wakad, Urbania for Office Trips Wakad, Best Urbania Rental Wakad Pune, Urbania Group Travel Wakad, Reliable Urbania Hire Wakad Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <div
                className="breadcumb-wrapper"
                
                data-overlay="black"
                data-opacity="3"
            >
                <div className="container">
                    <div className="breadcumb-content text-center">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/97.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>



                            <div className="shambhu-services">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="sh-service-card">

                                        <div className="sh-service-left">
                                            <div className="sh-service-icon">
                                                🚌
                                            </div>
                                        </div>

                                        <div className="sh-service-content">
                                            <h4 className="sh-service-title">{service.name}</h4>
                                            <p className="sh-service-desc">{service.description}</p>
                                        </div>

                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Urbania On rent in Pune </span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Urbania on rent in Pune </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919209423113" className="pc-call">+91 9209423113</a>
                                            <a href="tel:+917620411277 " className="pc-call">+91 7620411277 </a>
                                            <a href="tel:+919284718314" className="pc-call">+91 9284718314</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919209423113"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919209423113" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@urbaniaonrentpune.in" className="pc-email">
                                            booking@urbaniaonrentpune.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Urbania on rent in pune</strong><br />
                                            Saket Tata Power CHS, Swami Samarth Marg,
                                            Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                                            Maharashtra India - 400703
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Urbaniaonrentinwakad;